import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleRegisterVehicleSynchronizationChangeResponse from "./vehicleRegisterVehicleSynchronizationChangeResponse";
import VehicleRegisterVehicleSynchronizationStatus from "./vehicleRegisterVehicleSynchronizationStatus";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehicleSynchronizationResponse {
  @observable
  synchronizationStatus!: VehicleRegisterVehicleSynchronizationStatus;

  @observable
  @Type(() => Date)
  synchronizedAt!: Date;

  /**
   * The list of changes initiated by synchronization.
   */
  @observable
  @Type(() => VehicleRegisterVehicleSynchronizationChangeResponse)
  items!: VehicleRegisterVehicleSynchronizationChangeResponse[];
}
